import React from "react";
import styled, { css } from "styled-components";

import { Icons } from "src/library/components/Icon/types";
import { Icon } from "src/library/components/Icon";

import {
  IProduct,
  ProductReplacement
} from "../../api/products.api";
import ReplacementInput from "./ReplacementInputComponent";

export interface PlannedProductReplacementProps extends ProductReplacement{
  //handler to remove the line from the replacement array and in turn, the ui.
  removeReplacementHandler: () => void
  //handler to update the from product specifically
  updateFromProduct: (product?: IProduct) => void;
  //handler to update the to product specifically
  updateToProduct: (product?: IProduct) => void;

}

/**
 * A wrapper for the replacement inputs and delete button to represent a replacement line
 */
const PlannedProductReplacement: React.FunctionComponent<PlannedProductReplacementProps> = (
  {
    fromProduct, toProduct, removeReplacementHandler, updateFromProduct, updateToProduct
  }
) => {
  return (

    <PlannedWrapper>
      <div className="product">
        <ReplacementInput
          updateProduct={updateFromProduct}
          product={fromProduct}
          placeholder="Search for a product to replace"
        />
      </div>

      <div className="product">
        <ReplacementInput
          updateProduct={updateToProduct}
          product={toProduct}
          placeholder="Search for a replacement product"
        />
      </div>

      <div
        className="button-wrapper"
        onClick={() => {
          removeReplacementHandler();
        }}
      >
        <Icon
          icon={Icons.DELETE}
          size={20}
        />
      </div>

    </PlannedWrapper>

  );
};

const PlannedWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    margin-bottom: ${theme.spacing.margins.sm};
    margin-top: ${theme.spacing.margins.sm};
    justify-content: center;
    
    .selected-product missing-product span {
      display: inline-block;
      padding: ${theme.spacing.padding.sm};
      margin: ${theme.spacing.margins.sm} 0;
      border-radius: ${theme.borderRadius};
      background: ${theme.colors.lightGrey};
    }

    .product{
      display: flex;
      flex-direction: column;
      justify-content: center;
      flex:1;
    }
    
    .button-wrapper{
      display:flex;
      align-self: center;
      cursor: pointer;
    }

  `}
`;

export default PlannedProductReplacement;
